module.exports = __webpack_public_path__ + "media/images/common/credit_cards/google-pay-70e5f399a4fd71e4475ff3bd58820cee.svg";